import { IDocumentOfTitleAssetsUpdate } from "./interfaces";
import dayjs from 'dayjs';

export function UpdateDocumentOfTitleAssets(this: IDocumentOfTitleAssetsUpdate) {
  return {
    assetId: this.assetId,
    entityId: this.entityId,
    entityType: this.entityType,
    estimatedValue: this.estimatedValue,
    valuationAmount: this.valuationAmount,
    valuationDate:
      this.valuationDate && dayjs(this.valuationDate).isValid()
        ? dayjs(this.valuationDate).format("YYYY-MM-DD")
        : null,
    SNR: this.snr,
    nameOfHousing: this.nameOfHousing,
    ninForHousingCompany: this.ninForHousingCompany,
    description: this.description,
    ownedPart: this.ownedPart,
    postalCode: this.postalCode,
    municipalityCode: this.municipalityCode,
    comment: this.comment,
  };
}
